<template>
  <el-dialog title="BOM库存明细" :close-on-click-modal="false" :visible.sync="visible" width="980px" append-to-body>
    <div style="margin-bottom:10px">主产品编码：{{ materialCode }}</div>
    <el-table
      :data="dataList"
      border
      v-loading="loading"
      row-key="bomId"
      default-expand-all
      :tree-props="{ children: 'children' }"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="materialCode" label="子件编码" min-width="130" show-overflow-tooltip />
      <el-table-column prop="materialName" label="子件名称" min-width="150" show-overflow-tooltip />
      <el-table-column prop="customerCode" label="客户编码" min-width="120" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格型号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="classifyName" label="产品分类" min-width="120" show-overflow-tooltip />
      <el-table-column prop="unitName" label="库存单位" width="90" />
      <el-table-column prop="bomQuantity" label="BOM数量" width="100" align="right" />
      <el-table-column prop="quantity" label="库存数量" width="100" align="right" />
      <el-table-column prop="usableQuantity" label="可用库存" width="100" align="right" />
      <el-table-column prop="completeSetQuantity" label="齐套数量" width="100" align="right">
        <template slot-scope="s">{{ formatQty(s.row.completeSetQuantity) }}</template>
      </el-table-column>
    </el-table>
    <span slot="footer"><el-button @click="visible = false">关闭</el-button></span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'

function toTree(list) {
  const map = {}
  const roots = []
  ;(list || []).forEach(item => {
    const row = { ...item, children: [] }
    map[row.bomId] = row
  })
  Object.values(map).forEach(row => {
    const pid = row.parentId && row.parentId !== row.bomId ? row.parentId : '0'
    if (pid && pid !== '0' && map[pid]) map[pid].children.push(row)
    else roots.push(row)
  })
  return roots
}

export default {
  name: 'QuantitySearchBom',
  data() {
    return { visible: false, loading: false, materialCode: '', dataList: [] }
  },
  methods: {
    formatQty(v) {
      if (v == null || v === '') return '0'
      const n = Number(v)
      if (Number.isNaN(n)) return '0'
      return n.toLocaleString('zh-CN', { maximumFractionDigits: 4 })
    },
    init(materialCode) {
      this.visible = true
      this.materialCode = materialCode || ''
      this.loading = true
      request.get('/inventory/quantity/bomList', { params: { materialCode: this.materialCode } }).then(res => {
        const body = res.data || {}
        const list = body.list || []
        this.dataList = toTree(list)
      }).catch(() => { this.dataList = [] }).finally(() => { this.loading = false })
    }
  }
}
</script>
